import * as React from 'react';
import { TabTableContainer, Title } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { formatColWithDate, valueGridMoneyFormatter } from '@components/datagrid/custom.datagrid.props';

const columns = [
  { field: 'bonusPercent', headerName: 'Percentage', width: 150 },
  { field: 'creationDate', headerName: 'Start', ...formatColWithDate, width: 170 },
  { field: 'closed', headerName: 'Used', width: 120 },
  { field: 'closedDate', headerName: 'Used Date', ...formatColWithDate, width: 170 },
  { field: 'expireDate', headerName: 'Expired Date', ...formatColWithDate, width: 170 },
  { field: 'tag', headerName: 'Tag' },
];

interface BonusData {
  bonusPercent: number;
  creationDate: string;
  closed: boolean;
  closedDate: number;
  expireDate: string;
  tag: number;
}

let index = 0;
function createData(bonusData: BonusData) {
  index += 1;
  return { id: index, ...bonusData };
}

const PlayerPaymentsBonus = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<BonusData[]>(`/admin/bonus/player/${requestPid}`, { params: { page }, cancelToken });
  }
  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });

  const rows = responseData?.map(createData) || [];
  // const rows = responseData || [];

  const total = rows.length;

  return (
    <>
      <TabTableContainer>
        <Title>Bonus ({total})</Title>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </TabTableContainer>
    </>
  );
};

export default PlayerPaymentsBonus;
